import React, { useEffect } from 'react';
import { /* BrowserRouter as Router, */ HashRouter as Router, Route, Switch, Redirect } from "react-router-dom";

import { useDispatch, useSelector } from 'react-redux';

import { history, Role } from '../_helpers';
import { alertActions } from '../_actions';
import { Navigation, PrivateRoute } from '../_components';
import { Application, ChangePassword, PersonalInfo, ContactUs } from '../ApplicationPage';
import { CS2PlusPage } from '../CS2PlusPage';
import { LoginPage } from '../LoginPage';

import { AdminPage } from '../AdminPage';


function App() {
    const alert = useSelector(state => state.alert);
    const dispatch = useDispatch();

    useEffect(() => {
        history.listen((location, action) => {
            // clear alert on location change
            dispatch(alertActions.clear());
        });
    }, []);
    return (
    		<div>
    			<Navigation />
	    		<Router>
					<Switch>
						<PrivateRoute exact path="/" component={Application} />
						<Route path="/login" component={LoginPage} />
		                <PrivateRoute path="/applications" component={Application} replace />
		                <PrivateRoute path="/changepassword" component={ChangePassword} replace />
		                <PrivateRoute path="/personalinformation" component={PersonalInfo} replace />
		                <PrivateRoute path="/contactus" component={ContactUs} replace />
						
		                		
		                <PrivateRoute path="/admin" roles={[Role.Admin]} component={AdminPage} />
		                <PrivateRoute path="/cs2plus" roles={[Role.CS2PlusUsers]} component={CS2PlusPage} replace />
						<Redirect path="/*" to="/applications" />
					</Switch>
				</Router>
				</div>
        );
    
}

export { App };